"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dateComparisons = [
    "is",
    "is_not",
    "is_empty",
    "is_not_empty",
    "is_within",
    "is_not_within",
    "is_before",
    "is_after",
    "is_on_or_before",
    "is_on_or_after",
];
